import { createGtm } from '@gtm-support/vue-gtm'

export const gtm = createGtm({
  id: import.meta.env.PUBLIC_ENV__GTM_CONTAINER_ID,
  defer: true,
  debug: import.meta.env.DEV,
})
